import { type ReactElement } from 'react'
import { useDisclosure } from '@mantine/hooks'
import { type PickUserDrawerProps, PickUserDrawer } from './PickUserDrawer'
import { type UserButtonProps, UserButton } from './UserButton'

export type PickUserProps = Omit<UserButtonProps, 'onClick'> & Omit<PickUserDrawerProps, 'isOpen' | 'close'>
export const PickUser = ({ label, userId, ...drawerProps }: PickUserProps): ReactElement => {
  const [opened, { open, close }] = useDisclosure()
  return (
    <>
      <UserButton label={label} userId={userId} onClick={open} />
      <PickUserDrawer close={close} isOpen={opened} {...drawerProps} />
    </>
  )
}
